type StoredUserData = {
  email?: string;
  country?: string;
  location?: string;
};

const normalizeEmail = (email?: string) => (email || '').trim().toLowerCase();

const getInternalEmails = () => {
  const envEmails = process.env.REACT_APP_INTERNAL_EMAILS || process.env.REACT_APP_DEVELOPER_EMAILS || '';
  return new Set(
    envEmails
      .split(/[,;\n]/)
      .map((email) => email.trim().toLowerCase())
      .filter(Boolean)
  );
};

export const getStoredAnalyticsUserData = (): StoredUserData => {
  try {
    const userDataRaw = localStorage.getItem('userData');
    if (!userDataRaw) return {};
    return JSON.parse(userDataRaw) as StoredUserData;
  } catch (e) {
    console.error('Error parsing localStorage data for analytics user properties', e);
    return {};
  }
};

export const shouldCollectAnalytics = () => {
  const internalEmails = getInternalEmails();
  const { email } = getStoredAnalyticsUserData();
  const normalizedUserEmail = normalizeEmail(email);

  if (!normalizedUserEmail) {
    return false;
  }

  return !internalEmails.has(normalizedUserEmail);
};

export const resolveAnalyticsUserType = (email?: string) => {
  const internalEmails = getInternalEmails();
  const normalizedUserEmail = normalizeEmail(email);

  if (!normalizedUserEmail) {
    return 'unknown';
  }

  if (internalEmails.has(normalizedUserEmail)) {
    return 'internal';
  }

  return 'customer';
};
